import { withStyles } from '@mui/styles';
import { Tab as MuiTab } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';

const styles = (theme) => ({
    tab: {
        backgroundColor: '#EBEBEB',
        borderRadius: '5px 5px 0 0',
        marginRight: '10px',
        textTransform: 'none',
        color: COLORS.LT_MIDNIGHT,
        fontSize: '12px',
        fontWeight: '600',
        borderBottom: 'none',
        minHeight: 'initial',
        paddingTop: '10px',
        paddingBottom: '10px',

        '&.Mui-selected': {
            color: COLORS.LT_MIDNIGHT,
            backgroundColor: COLORS.WHITE,
        },
    },
});

function Tab({ label, index, value, classes, ...other }) {
    return (
        <MuiTab
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`}
            tabIndex={index}
            label={label}
            value={value}
            className={classes.tab}
            disableRipple
            {...other}
        />
    );
}

export default withStyles(styles)(Tab);
